import { createSelector } from 'reselect';
import { getUsersState } from 'src/modules/users/selectors/getUsersState';

export const getUsersSortingOrder = createSelector([
  getUsersState,
], (state) => state.sortingOrder);
